import { Stack, Typography } from "@mui/material"
import Section from "./Section"

export default function Quote() {
  return (
    <Section>
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{
          borderRadius: "12px",
          background: "rgba(255, 255, 255, 0.02)",
          border: "1px solid rgba(255, 255, 255, 0.03)",
          p: 1.5,
        }}
      >
        <Typography
          color="rgb(79, 150, 13)"
          variant="h4"
          fontSize="20px"
          fontWeight="bold"
        >
          Ne sous-estimez pas les gaspillages engendrés par un mapping-slotting
          imparfait !
        </Typography>
      </Stack>
    </Section>
  )
}
